import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useGetLoggedUser } from "../../shared/hooks/useUser";

const LoginProtected = ({ children }) => {
    const { data: loggedUser, status } = useGetLoggedUser(true);

    const [loggedIn, setLoggedIn] = useState();

    useEffect(() => {
        // If user is not logged in, stay on /login
        if (status === "error") {
            setLoggedIn(false);
            return;
        }

        if (status === "success") {
            if (!loggedUser) {
                setLoggedIn(false);
                return;
            }
            if (loggedUser.user_type && loggedUser.user_type !== "Website User") {
                setLoggedIn(true);
            } else {
                setLoggedIn(false);
            }
        }
    }, [loggedUser, status]);

    if (loggedIn) {
        const isKitchen = loggedUser?.role_profile_name === "Kitchen";
        return <Navigate to={isKitchen ? "/kds/MainDishes" : "/tables"} replace />;
        // return <Navigate to={isKitchen ? "/kds/Kitchen" : "/tables"} replace />;
        
    }
    return children;
};

export default LoginProtected;
